// import {
//   Email as EmailIcon,
//   Facebook as FacebookIcon,
//   Instagram as InstagramIcon,
//   LinkedIn as LinkedInIcon,
//   Phone as PhoneIcon,
//   Twitter as TwitterIcon,
//   YouTube as YouTubeIcon,
//   LocationOn as LocationIcon,
//   AccessTime as TimeIcon,
//   ArrowUpward as ArrowUpIcon,
//   Send as SendIcon,
//   Rocket as RocketIcon,
//   Code as CodeIcon,
//   Security as SecurityIcon,
//   Speed as SpeedIcon,
//   Support as SupportIcon
// } from '@mui/icons-material';
// import {
//   Box,
//   Container,
//   Divider,
//   Grid,
//   IconButton,
//   Typography,
//   Button,
//   TextField,
//   InputAdornment,
//   Paper,
//   Chip,
//   Stack,
//   useTheme,
//   useMediaQuery,
//   Fade,
//   Slide
// } from '@mui/material';
// import { useState, useEffect } from 'react';

// const Footer = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const [email, setEmail] = useState('');
//   const [showScrollTop, setShowScrollTop] = useState(false);

//   // Scroll to top functionality
//   useEffect(() => {
//     const handleScroll = () => {
//       setShowScrollTop(window.scrollY > 300);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   };

//   const handleNewsletterSubmit = (e) => {
//     e.preventDefault();
//     // Newsletter logic here
//     console.log('Newsletter subscription:', email);
//     setEmail('');
//   };

//   const quickLinks = [
//     { name: 'Haber Yazılımı', icon: <CodeIcon /> },
//     { name: 'Mobil Uygulama', icon: <PhoneIcon /> },
//     { name: 'Öğeler & Elementler', icon: <RocketIcon /> },
//     { name: 'Demo Siteler', icon: <SecurityIcon /> },
//     { name: 'Referanslar', icon: <SpeedIcon /> },
//     { name: 'Blog', icon: <SupportIcon /> }
//   ];

//   const legalLinks = [
//     { name: 'Hizmet Sözleşmesi', icon: <SecurityIcon /> },
//     { name: 'KVKK Politikası', icon: <SecurityIcon /> },
//     { name: 'Çerez Politikası', icon: <SecurityIcon /> },
//     { name: 'Kullanım Koşulları', icon: <SecurityIcon /> }
//   ];

//   const services = [
//     { icon: <CodeIcon />, title: 'Haber Yazılımı', desc: 'Modern CMS çözümleri' },
//     { icon: <SecurityIcon />, title: 'Güvenlik', desc: 'SSL & Güvenlik sertifikaları' },
//     { icon: <SpeedIcon />, title: 'Performans', desc: 'Hızlı ve optimize edilmiş' },
//     { icon: <SupportIcon />, title: 'Destek', desc: '7/24 teknik destek' }
//   ];

//   const socialLinks = [
//     { icon: <FacebookIcon />, color: '#1877f2', label: 'Facebook' },
//     { icon: <TwitterIcon />, color: '#1da1f2', label: 'Twitter' },
//     { icon: <LinkedInIcon />, color: '#0077b5', label: 'LinkedIn' },
//     { icon: <InstagramIcon />, color: '#e4405f', label: 'Instagram' },
//     { icon: <YouTubeIcon />, color: '#ff0000', label: 'YouTube' }
//   ];

//   return (
//     <Box sx={{ position: 'relative' }}>
//       {/* Newsletter Section */}
//       <Box 
//         sx={{ 
//           bgcolor: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//           background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
//           py: 8,
//           position: 'relative',
//           overflow: 'hidden',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="11" cy="11" r="2"/%3E%3Ccircle cx="49" cy="11" r="2"/%3E%3Ccircle cx="11" cy="49" r="2"/%3E%3Ccircle cx="49" cy="49" r="2"/%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
//             opacity: 0.3
//           }
//         }}
//       >
//         <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box>
//                   <Typography 
//                     variant="h3" 
//                     fontWeight={800} 
//                     color="white" 
//                     gutterBottom
//                     sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}
//                   >
//                     Haberlerden Haberdar Olun
//                   </Typography>
//                   <Typography 
//                     variant="h6" 
//                     color="rgba(255,255,255,0.9)" 
//                     sx={{ mb: 4, lineHeight: 1.6 }}
//                   >
//                     Yeni özellikler, güncellemeler ve özel tekliflerden ilk siz haberdar olun.
//                     Aylık bültenimize abone olarak sektördeki son gelişmeleri takip edin.
//                   </Typography>
                  
//                   <Stack direction="row" spacing={2} flexWrap="wrap" gap={1}>
//                     <Chip 
//                       icon={<RocketIcon />}
//                       label="Yeni Özellikler" 
//                       sx={{ 
//                         bgcolor: 'rgba(255,255,255,0.2)', 
//                         color: 'white',
//                         fontWeight: 600,
//                         backdropFilter: 'blur(10px)'
//                       }} 
//                     />
//                     <Chip 
//                       icon={<CodeIcon />}
//                       label="Teknik İpuçları" 
//                       sx={{ 
//                         bgcolor: 'rgba(255,255,255,0.2)', 
//                         color: 'white',
//                         fontWeight: 600,
//                         backdropFilter: 'blur(10px)'
//                       }} 
//                     />
//                     <Chip 
//                       icon={<SupportIcon />}
//                       label="Özel Teklifler" 
//                       sx={{ 
//                         bgcolor: 'rgba(255,255,255,0.2)', 
//                         color: 'white',
//                         fontWeight: 600,
//                         backdropFilter: 'blur(10px)'
//                       }} 
//                     />
//                   </Stack>
//                 </Box>
//               </Fade>
//             </Grid>
            
//             <Grid item xs={12} md={6}>
//               <Slide direction="left" in timeout={1200}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 4,
//                     bgcolor: 'rgba(255,255,255,0.1)',
//                     backdropFilter: 'blur(20px)',
//                     border: '1px solid rgba(255,255,255,0.2)',
//                     borderRadius: 4
//                   }}
//                 >
//                   <Typography 
//                     variant="h5" 
//                     fontWeight={700} 
//                     color="white" 
//                     gutterBottom
//                     sx={{ mb: 3 }}
//                   >
//                     📧 Bültene Abone Ol
//                   </Typography>
                  
//                   <Box component="form" onSubmit={handleNewsletterSubmit}>
//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       placeholder="E-posta adresinizi girin"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       sx={{
//                         mb: 3,
//                         '& .MuiOutlinedInput-root': {
//                           bgcolor: 'rgba(255,255,255,0.9)',
//                           borderRadius: 3,
//                           '& fieldset': {
//                             borderColor: 'transparent'
//                           },
//                           '&:hover fieldset': {
//                             borderColor: 'rgba(255,255,255,0.5)'
//                           },
//                           '&.Mui-focused fieldset': {
//                             borderColor: 'white'
//                           }
//                         },
//                         '& .MuiInputBase-input': {
//                           py: 2
//                         }
//                       }}
//                       InputProps={{
//                         endAdornment: (
//                           <InputAdornment position="end">
//                             <IconButton 
//                               type="submit"
//                               sx={{ 
//                                 color: '#1976d2',
//                                 '&:hover': { 
//                                   bgcolor: 'rgba(25, 118, 210, 0.1)' 
//                                 }
//                               }}
//                             >
//                               <SendIcon />
//                             </IconButton>
//                           </InputAdornment>
//                         )
//                       }}
//                     />
                    
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       fullWidth
//                       startIcon={<SendIcon />}
//                       sx={{
//                         bgcolor: 'white',
//                         color: '#1976d2',
//                         fontWeight: 700,
//                         py: 2,
//                         borderRadius: 3,
//                         textTransform: 'none',
//                         fontSize: '1.1rem',
//                         '&:hover': {
//                           bgcolor: 'rgba(255,255,255,0.9)',
//                           transform: 'translateY(-2px)',
//                           boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
//                         },
//                         transition: 'all 0.3s ease'
//                       }}
//                     >
//                       Abone Ol
//                     </Button>
//                   </Box>
                  
//                   <Typography 
//                     variant="caption" 
//                     color="rgba(255,255,255,0.7)" 
//                     sx={{ mt: 2, display: 'block', textAlign: 'center' }}
//                   >
//                     Spam göndermiyoruz. İstediğiniz zaman abonelikten çıkabilirsiniz.
//                   </Typography>
//                 </Paper>
//               </Slide>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* Main Footer */}
//       <Box sx={{ bgcolor: '#0a0a0f', color: 'white', py: 8 }}>
//         <Container maxWidth="xl">
//           <Grid container spacing={6}>
//             {/* Company Info */}
//             <Grid item xs={12} md={4}>
//               <Box sx={{ mb: 4 }}>
//                 <Typography 
//                   variant="h4" 
//                   gutterBottom 
//                   fontWeight={800}
//                   sx={{ 
//                     color: '#1976d2',
//                     fontSize: '2.5rem',
//                     mb: 3
//                   }}
//                 >
//                   RONESİS
//                 </Typography>
//                 <Typography 
//                   variant="body1" 
//                   sx={{ 
//                     mb: 4, 
//                     opacity: 0.9, 
//                     lineHeight: 1.8,
//                     fontSize: '1.1rem'
//                   }}
//                 >
//                   Türkiye'nin önde gelen haber yazılımı ve IT çözümleri şirketi. 
//                   2010'dan beri sektörde lider konumdayız. Modern teknolojiler ile 
//                   müşterilerimize en iyi hizmeti sunuyoruz.
//                 </Typography>
                
//                 {/* Services Grid */}
//                 <Grid container spacing={2}>
//                   {services.map((service, index) => (
//                     <Grid item xs={6} key={index}>
//                       <Paper
//                         elevation={0}
//                         sx={{
//                           p: 2,
//                           bgcolor: 'rgba(255,255,255,0.05)',
//                           border: '1px solid rgba(255,255,255,0.1)',
//                           borderRadius: 3,
//                           textAlign: 'center',
//                           transition: 'all 0.3s ease',
//                           '&:hover': {
//                             bgcolor: 'rgba(25, 118, 210, 0.1)',
//                             borderColor: 'rgba(25, 118, 210, 0.3)',
//                             transform: 'translateY(-4px)'
//                           }
//                         }}
//                       >
//                         <Box sx={{ color: '#1976d2', mb: 1 }}>
//                           {service.icon}
//                         </Box>
//                         <Typography variant="caption" fontWeight={600} display="block">
//                           {service.title}
//                         </Typography>
//                         <Typography variant="caption" sx={{ opacity: 0.7, fontSize: '0.7rem' }}>
//                           {service.desc}
//                         </Typography>
//                       </Paper>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Box>
//             </Grid>

//             {/* Quick Links */}
//             <Grid item xs={12} sm={6} md={2}>
//               <Typography 
//                 variant="h6" 
//                 gutterBottom 
//                 fontWeight={700}
//                 sx={{ color: '#1976d2', mb: 3 }}
//               >
//                 Hızlı Linkler
//               </Typography>
//               <Box component="ul" sx={{ listStyle: 'none', p: 0 }}>
//                 {quickLinks.map((link, index) => (
//                   <Box component="li" key={link.name} sx={{ mb: 2 }}>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 1.5,
//                         opacity: 0.8,
//                         cursor: 'pointer',
//                         fontSize: '1rem',
//                         fontWeight: 500,
//                         position: 'relative',
//                         '&:hover': {
//                           opacity: 1,
//                           color: '#42a5f5',
//                           transform: 'translateX(8px)',
//                           '& .link-icon': {
//                             transform: 'scale(1.2) rotate(10deg)',
//                             color: '#42a5f5'
//                           }
//                         },
//                         transition: 'all 0.3s ease'
//                       }}
//                     >
//                       <Box
//                         className="link-icon"
//                         sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           color: '#1976d2',
//                           transition: 'all 0.3s ease',
//                           '& svg': {
//                             fontSize: '1.1rem'
//                           }
//                         }}
//                       >
//                         {link.icon}
//                       </Box>
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           fontSize: '1rem',
//                           fontWeight: 500
//                         }}
//                       >
//                         {link.name}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             </Grid>

//             {/* Legal Links */}
//             <Grid item xs={12} sm={6} md={2}>
//               <Typography 
//                 variant="h6" 
//                 gutterBottom 
//                 fontWeight={700}
//                 sx={{ color: '#1976d2', mb: 3 }}
//               >
//                 Yasal
//               </Typography>
//               <Box component="ul" sx={{ listStyle: 'none', p: 0 }}>
//                 {legalLinks.map((link, index) => (
//                   <Box component="li" key={link.name} sx={{ mb: 2 }}>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 1.5,
//                         opacity: 0.8,
//                         cursor: 'pointer',
//                         fontSize: '1rem',
//                         fontWeight: 500,
//                         position: 'relative',
//                         '&:hover': {
//                           opacity: 1,
//                           color: '#42a5f5',
//                           transform: 'translateX(8px)',
//                           '& .link-icon': {
//                             transform: 'scale(1.2) rotate(10deg)',
//                             color: '#42a5f5'
//                           }
//                         },
//                         transition: 'all 0.3s ease'
//                       }}
//                     >
//                       <Box
//                         className="link-icon"
//                         sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           color: '#1976d2',
//                           transition: 'all 0.3s ease',
//                           '& svg': {
//                             fontSize: '1.1rem'
//                           }
//                         }}
//                       >
//                         {link.icon}
//                       </Box>
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           fontSize: '1rem',
//                           fontWeight: 500
//                         }}
//                       >
//                         {link.name}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             </Grid>

//             {/* Contact Info */}
//             <Grid item xs={12} md={4}>
//               <Typography 
//                 variant="h6" 
//                 gutterBottom 
//                 fontWeight={700}
//                 sx={{ color: '#1976d2', mb: 3 }}
//               >
//                 İletişim Bilgileri
//               </Typography>
              
//               <Stack spacing={3} sx={{ mb: 4 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <Box
//                     sx={{
//                       bgcolor: 'rgba(25, 118, 210, 0.2)',
//                       borderRadius: 2,
//                       p: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center'
//                     }}
//                   >
//                     <PhoneIcon sx={{ color: '#1976d2' }} />
//                   </Box>
//                   <Box>
//                     <Typography variant="body1" fontWeight={600}>
//                       +90 (212) 322 74 90
//                     </Typography>
//                     <Typography variant="caption" sx={{ opacity: 0.7 }}>
//                       Pazartesi - Cuma: 09:00 - 18:00
//                     </Typography>
//                   </Box>
//                 </Box>

//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <Box
//                     sx={{
//                       bgcolor: 'rgba(25, 118, 210, 0.2)',
//                       borderRadius: 2,
//                       p: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center'
//                     }}
//                   >
//                     <EmailIcon sx={{ color: '#1976d2' }} />
//                   </Box>
//                   <Box>
//                     <Typography variant="body1" fontWeight={600}>
//                       info@tebilisim.com
//                     </Typography>
//                     <Typography variant="caption" sx={{ opacity: 0.7 }}>
//                       7/24 destek için
//                     </Typography>
//                   </Box>
//                 </Box>

//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <Box
//                     sx={{
//                       bgcolor: 'rgba(25, 118, 210, 0.2)',
//                       borderRadius: 2,
//                       p: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center'
//                     }}
//                   >
//                     <LocationIcon sx={{ color: '#1976d2' }} />
//                   </Box>
//                   <Box>
//                     <Typography variant="body1" fontWeight={600}>
//                       İstanbul, Türkiye
//                     </Typography>
//                     <Typography variant="caption" sx={{ opacity: 0.7 }}>
//                       Merkez ofis
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Stack>

//               {/* Social Media */}
//               <Typography 
//                 variant="h6" 
//                 gutterBottom 
//                 fontWeight={700}
//                 sx={{ color: '#1976d2', mb: 2 }}
//               >
//                 Sosyal Medya
//               </Typography>
//               <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
//                 {socialLinks.map((social, index) => (
//                   <IconButton
//                     key={index}
//                     sx={{
//                       bgcolor: 'rgba(255,255,255,0.05)',
//                       border: '1px solid rgba(255,255,255,0.1)',
//                       color: 'white',
//                       width: 50,
//                       height: 50,
//                       '&:hover': {
//                         bgcolor: social.color,
//                         borderColor: social.color,
//                         transform: 'translateY(-4px) scale(1.1)',
//                         boxShadow: `0 8px 25px ${social.color}40`
//                       },
//                       transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
//                     }}
//                     aria-label={social.label}
//                   >
//                     {social.icon}
//                   </IconButton>
//                 ))}
//               </Stack>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* Bottom Bar */}
//       <Box sx={{ bgcolor: '#000', py: 3, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
//         <Container maxWidth="xl">
//           <Box 
//             sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center', 
//               flexWrap: 'wrap', 
//               gap: 2 
//             }}
//           >
//             <Typography variant="body2" sx={{ opacity: 0.7, color: 'white' }}>
//               © 2024 TE Bilişim. Tüm hakları saklıdır. | Tasarım ve Geliştirme: TE Bilişim
//             </Typography>
            
//             <Stack direction="row" spacing={3} sx={{ opacity: 0.7 }}>
//               <Typography variant="caption" sx={{ color: 'white' }}>
//                 v2.1.0
//               </Typography>
//               <Typography variant="caption" sx={{ color: 'white' }}>
//                 Son güncelleme: 2024
//               </Typography>
//             </Stack>
//           </Box>
//         </Container>
//       </Box>

//       {/* Scroll to Top Button */}
//       <Fade in={showScrollTop}>
//         <IconButton
//           onClick={scrollToTop}
//           sx={{
//             position: 'fixed',
//             bottom: 30,
//             right: 30,
//             bgcolor: '#1976d2',
//             color: 'white',
//             width: 60,
//             height: 60,
//             boxShadow: '0 8px 25px rgba(25, 118, 210, 0.4)',
//             zIndex: 1000,
//             '&:hover': {
//               bgcolor: '#1565c0',
//               transform: 'translateY(-4px) scale(1.1)',
//               boxShadow: '0 12px 35px rgba(25, 118, 210, 0.6)'
//             },
//             transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
//           }}
//         >
//           <ArrowUpIcon />
//         </IconButton>
//       </Fade>
//     </Box>
//   );
// };

// export default Footer;


import {
  Email as EmailIcon,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  Phone as PhoneIcon,
  Twitter as TwitterIcon,
  YouTube as YouTubeIcon,
  LocationOn as LocationIcon,
  ArrowUpward as ArrowUpIcon,
  Send as SendIcon,
  Rocket as RocketIcon,
  Code as CodeIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  Support as SupportIcon,
  CheckCircle as CheckIcon,
  TrendingUp as TrendingIcon,
  People as PeopleIcon,
  Star as StarIcon
} from '@mui/icons-material';
import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  Typography,
  Button,
  TextField,
  InputAdornment,
  Paper,
  Chip,
  Stack,
  useTheme,
  useMediaQuery,
  Fade,
  Avatar,
  Link,
  alpha
} from '@mui/material';
import { useState, useEffect } from 'react';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [email, setEmail] = useState('');
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [newsletterSuccess, setNewsletterSuccess] = useState(false);

  // Scroll to top functionality
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      console.log('Newsletter subscription:', email);
      setNewsletterSuccess(true);
      setEmail('');
      setTimeout(() => setNewsletterSuccess(false), 3000);
    }
  };

  const quickLinks = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Haber Yazılımı', path: '/features' },
    { name: 'Widget Galerisi', path: '/widgets' },
    { name: 'Fiyatlandırma', path: '/pricing' },
    { name: 'Demo Siteler', path: '/demos' },
    { name: 'Blog', path: '/blog' }
  ];

  const features = [
    { name: 'Haber İçerik Yönetimi', path: '/content-management' },
    { name: 'Sayfa Tasarımcısı', path: '/page-designer' },
    { name: 'Kullanıcı Yönetimi', path: '/user-management' },
    { name: 'Abonelik Sistemi', path: '/subscription' },
    { name: 'Tema Yönetimi', path: '/theme-design' },
    //{ name: 'Mobil Uygulama', path: '/mobile-app' }
  ];

  const legalLinks = [
    { name: 'Hizmet Sözleşmesi', path: '/terms' },
    { name: 'Gizlilik Politikası', path: '/privacy' },
    { name: 'KVKK Politikası', path: '/kvkk' },
    { name: 'Çerez Politikası', path: '/cookies' }
  ];

  const services = [
    { icon: <CodeIcon />, title: 'Haber Yazılımı', desc: 'Modern CMS' },
    { icon: <SecurityIcon />, title: 'Güvenlik', desc: 'SSL & Sertifika' },
    { icon: <SpeedIcon />, title: 'Performans', desc: 'Hızlı & Optimize' },
    { icon: <SupportIcon />, title: 'Destek', desc: '7/24 Teknik' }
  ];

  const socialLinks = [
    { icon: <FacebookIcon />, color: '#1877f2', label: 'Facebook', url: '#' },
    { icon: <TwitterIcon />, color: '#1da1f2', label: 'Twitter', url: '#' },
    { icon: <LinkedInIcon />, color: '#0077b5', label: 'LinkedIn', url: '#' },
    { icon: <InstagramIcon />, color: '#e4405f', label: 'Instagram', url: '#' },
    { icon: <YouTubeIcon />, color: '#ff0000', label: 'YouTube', url: '#' }
  ];

  const stats = [
    { icon: <PeopleIcon />, value: '500+', label: 'Aktif Müşteri' },
    { icon: <TrendingIcon />, value: '1M+', label: 'Günlük Okuyucu' },
    { icon: <StarIcon />, value: '4.9/5', label: 'Müşteri Memnuniyeti' },
    { icon: <CheckIcon />, value: '99.9%', label: 'Uptime' }
  ];

  return (
    <Box sx={{ position: 'relative', bgcolor: '#0a0a0f' }}>

      {/* Main Footer */}
      <Box sx={{ bgcolor: '#0a0a0f', color: 'white', py: { xs: 6, md: 10 } }}>
        <Container maxWidth="xl">
          <Grid container spacing={{ xs: 4, md: 6 }}>
            {/* Company Info */}
            <Grid item xs={12} md={4}>
              <Box sx={{ mb: 3 }}>
                {/* Logo */}
                <Stack direction="row" alignItems="center" spacing={1.5} mb={3}>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: 2.5,
                      background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '2rem',
                      boxShadow: '0 8px 20px rgba(25, 118, 210, 0.3)'
                    }}
                  >
                    📰
                  </Box>
                  <Box>
                    <Typography 
                      variant="h5" 
                      fontWeight={900}
                      sx={{ 
                        color: '#1976d2',
                        lineHeight: 1
                      }}
                    >
                      RONESİS
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: 'rgba(255,255,255,0.6)',
                        fontSize: '0.75rem',
                        fontWeight: 600
                      }}
                    >
                      Haber Platformu
                    </Typography>
                  </Box>
                </Stack>

                <Typography 
                  variant="body1" 
                  sx={{ 
                    mb: 3, 
                    color: 'rgba(255,255,255,0.8)', 
                    lineHeight: 1.8,
                    fontSize: '1rem'
                  }}
                >
                  Türkiye'nin önde gelen haber yazılımı ve IT çözümleri şirketi. 
                  2010'dan beri sektörde lider konumdayız. Modern teknolojiler ile 
                  müşterilerimize en iyi hizmeti sunuyoruz.
                </Typography>
                
                {/* Services Grid */}
                <Grid container spacing={1.5}>
                  {services.map((service, index) => (
                    <Grid item xs={6} key={index}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 2,
                          bgcolor: 'rgba(255,255,255,0.03)',
                          border: '1px solid rgba(255,255,255,0.1)',
                          borderRadius: 2,
                          textAlign: 'center',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            bgcolor: 'rgba(25, 118, 210, 0.1)',
                            borderColor: 'rgba(25, 118, 210, 0.3)',
                            transform: 'translateY(-2px)'
                          }
                        }}
                      >
                        <Box sx={{ color: '#42a5f5', mb: 1 }}>
                          {service.icon}
                        </Box>
                        <Typography variant="caption" fontWeight={700} display="block" color="white">
                          {service.title}
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.7rem' }}>
                          {service.desc}
                        </Typography>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>

            {/* Quick Links */}
            {/* <Grid item xs={6} md={2}>
              <Typography 
                variant="h6" 
                gutterBottom 
                fontWeight={700}
                sx={{ 
                  color: '#1976d2', 
                  mb: 3,
                  fontSize: '1.1rem'
                }}
              >
                Hızlı Linkler
              </Typography>
              <Stack spacing={1.5}>
                {quickLinks.map((link, index) => (
                  <Link
                    key={index}
                    href={link.path}
                    underline="none"
                    sx={{
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: '0.95rem',
                      fontWeight: 500,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        color: '#42a5f5',
                        transform: 'translateX(4px)'
                      }
                    }}
                  >
                    <Box
                      sx={{
                        width: 4,
                        height: 4,
                        borderRadius: '50%',
                        bgcolor: '#1976d2',
                        transition: 'all 0.3s ease'
                      }}
                    />
                    {link.name}
                  </Link>
                ))}
              </Stack>
            </Grid> */}

            {/* Features */}
            <Grid item xs={6} md={2}>
              <Typography 
                variant="h6" 
                gutterBottom 
                fontWeight={700}
                sx={{ 
                  color: '#1976d2', 
                  mb: 3,
                  fontSize: '1.1rem'
                }}
              >
                Özellikler
              </Typography>
              <Stack spacing={1.5}>
                {features.map((link, index) => (
                  <Link
                    key={index}
                    href={link.path}
                    underline="none"
                    sx={{
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: '0.95rem',
                      fontWeight: 500,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        color: '#42a5f5',
                        transform: 'translateX(4px)'
                      }
                    }}
                  >
                    <Box
                      sx={{
                        width: 4,
                        height: 4,
                        borderRadius: '50%',
                        bgcolor: '#1976d2',
                        transition: 'all 0.3s ease'
                      }}
                    />
                    {link.name}
                  </Link>
                ))}
              </Stack>
            </Grid>

            {/* Contact Info */}
            <Grid item xs={12} md={4}>
              <Typography 
                variant="h6" 
                gutterBottom 
                fontWeight={700}
                sx={{ 
                  color: '#1976d2', 
                  mb: 3,
                  fontSize: '1.1rem'
                }}
              >
                İletişim Bilgileri
              </Typography>
              
              <Stack spacing={2.5}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                  <Box
                    sx={{
                      bgcolor: 'rgba(25, 118, 210, 0.2)',
                      borderRadius: 2,
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minWidth: 48,
                      height: 48
                    }}
                  >
                    <PhoneIcon sx={{ color: '#42a5f5' }} />
                  </Box>
                  <Box>
                    <Typography variant="body1" fontWeight={600} color="white" mb={0.5}>
                      +90 (212) 322 74 90
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                      Pazartesi - Cuma: 09:00 - 18:00
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                  <Box
                    sx={{
                      bgcolor: 'rgba(25, 118, 210, 0.2)',
                      borderRadius: 2,
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minWidth: 48,
                      height: 48
                    }}
                  >
                    <EmailIcon sx={{ color: '#42a5f5' }} />
                  </Box>
                  <Box>
                    <Typography variant="body1" fontWeight={600} color="white" mb={0.5}>
                      info@ronesis.com
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                      7/24 destek için
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                  <Box
                    sx={{
                      bgcolor: 'rgba(25, 118, 210, 0.2)',
                      borderRadius: 2,
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minWidth: 48,
                      height: 48
                    }}
                  >
                    <LocationIcon sx={{ color: '#42a5f5' }} />
                  </Box>
                  <Box>
                    <Typography variant="body1" fontWeight={600} color="white" mb={0.5}>
                      Aydın, Türkiye
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                      Merkez ofis
                    </Typography>
                  </Box>
                </Box>
              </Stack>

              {/* Social Media */}
              <Box sx={{ mt: 4 }}>
                <Typography 
                  variant="h6" 
                  gutterBottom 
                  fontWeight={700}
                  sx={{ 
                    color: '#1976d2', 
                    mb: 2,
                    fontSize: '1.1rem'
                  }}
                >
                  Sosyal Medya
                </Typography>
                <Stack direction="row" spacing={1.5} flexWrap="wrap" gap={1}>
                  {socialLinks.map((social, index) => (
                    <IconButton
                      key={index}
                      component="a"
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        bgcolor: 'rgba(255,255,255,0.05)',
                        border: '1px solid rgba(255,255,255,0.1)',
                        color: 'white',
                        width: 48,
                        height: 48,
                        '&:hover': {
                          bgcolor: social.color,
                          borderColor: social.color,
                          transform: 'translateY(-4px) scale(1.05)',
                          boxShadow: `0 8px 25px ${social.color}40`
                        },
                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                      aria-label={social.label}
                    >
                      {social.icon}
                    </IconButton>
                  ))}
                </Stack>
              </Box>
            </Grid>
          </Grid>

          {/* Legal Links */}
          <Divider sx={{ my: 6, borderColor: 'rgba(255,255,255,0.1)' }} />
          
          {/* <Stack 
            direction={{ xs: 'column', md: 'row' }} 
            spacing={2}
            justifyContent="center"
            alignItems="center"
            mb={4}
          >
            {legalLinks.map((link, index) => (
              <Link
                key={index}
                href={link.path}
                underline="none"
                sx={{
                  color: 'rgba(255,255,255,0.6)',
                  fontSize: '0.9rem',
                  fontWeight: 500,
                  '&:hover': {
                    color: '#42a5f5'
                  },
                  transition: 'color 0.3s ease'
                }}
              >
                {link.name}
              </Link>
            ))}
          </Stack> */}
        </Container>
      </Box>

      {/* Bottom Bar */}
      <Box 
        sx={{ 
          bgcolor: '#000', 
          py: 3, 
          borderTop: '1px solid rgba(255,255,255,0.05)'
        }}
      >
        <Container maxWidth="xl">
          <Stack 
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="space-between" 
            alignItems="center" 
            spacing={2}
          >
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'rgba(255,255,255,0.6)',
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              © 2025 RÖNESANS. Tüm hakları saklıdır. | Tasarım ve Geliştirme: RÖNESANS
            </Typography>
            
            <Stack direction="row" spacing={3} sx={{ color: 'rgba(255,255,255,0.6)' }}>
              <Typography variant="caption">
                v2.1.0
              </Typography>
              <Typography variant="caption">
                Son güncelleme: 2025
              </Typography>
              <Chip
                label="Made with ❤️ in Turkey"
                size="small"
                sx={{
                  bgcolor: 'rgba(239, 68, 68, 0.1)',
                  color: '#ef4444',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  border: '1px solid rgba(239, 68, 68, 0.2)'
                }}
              />
            </Stack>
          </Stack>
        </Container>
      </Box>

      {/* Scroll to Top Button */}
      <Fade in={showScrollTop}>
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: 30,
            right: 30,
            background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
            color: 'white',
            width: 56,
            height: 56,
            boxShadow: '0 8px 25px rgba(25, 118, 210, 0.4)',
            zIndex: 1000,
            '&:hover': {
              background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
              transform: 'translateY(-4px) scale(1.05)',
              boxShadow: '0 12px 35px rgba(25, 118, 210, 0.6)'
            },
            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
          aria-label="Yukarı çık"
        >
          <ArrowUpIcon />
        </IconButton>
      </Fade>
    </Box>
  );
};

export default Footer;